import { render, staticRenderFns } from "./SaleTableFilter.vue?vue&type=template&id=595973ce&"
import script from "./SaleTableFilter.vue?vue&type=script&lang=js&"
export * from "./SaleTableFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports